module.exports = __webpack_public_path__ + "static/media/no-join@2x.b18d5dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_230/imgs/no-join@2x.png
// module id = 1761
// module chunks = 0